import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import s from '../styles.module.scss'

import FooterLogin from '../footer-login/footer-login'
import { SubscribeInterface } from '../login.types'
import { InputsLogin } from '../login-form/login-form'
import { InputText } from '../../../../components/molecules/input-text'
import regex from '../../../../utils/regex'

interface SubscribeForm extends SubscribeInterface {
  setShowSubscribe: React.Dispatch<React.SetStateAction<boolean>>
}

const SubscribeForm = ({
  title,
  onSubscribe,
  isLoading,
  setShowSubscribe,
  description,
  email = '',
}: SubscribeForm) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
    setError,
  } = useForm<InputsLogin>({
    defaultValues: {
      email,
      password: '',
    },
    mode: 'onChange',
  })

  const onSubmit: SubmitHandler<InputsLogin> = async ({ email, password }) => {
    try {
      await onSubscribe({ email, password })
    } catch (e) {
      setError('password', {
        type: 'string',
        message: 'Une erreur est survenue. Veuillez réessayer ultérieurement',
      })
      setError('email', {
        type: 'string',
        message: 'Une erreur est survenue. Veuillez réessayer ultérieurement',
      })
    }
  }

  return (
    <form className={s.form}>
      <h2 className={s.title}>{title}</h2>
      <div className={s.description}>{description}</div>
      <InputText
        control={control}
        name='email'
        label='Adresse e-mail'
        rules={{
          required: 'Une adresse e-mail est requise.',
          pattern: {
            value: regex.email,
            message: "Respecter le bon format d'e-mail",
          },
        }}
        inputProps={{
          type: 'text',
          'aria-label': 'entrez votre e-mail',
          'aria-required': 'true',
        }}
        placeholder='Entrez votre e-mail'
        disabled={!!email}
      />
      <InputText
        control={control}
        name='password'
        label='Mot de passe'
        rules={{
          validate: (password: string | undefined) =>
            password && password.length >= 6 ? true : 'Minimum 6 caractères',
        }}
        inputProps={{
          type: 'password',
          'aria-label': 'entrez votre mot de passe',
          'aria-required': 'true',
        }}
        placeholder='Entrez votre mot de passe'
      />

      <FooterLogin
        footerElement={
          <div className={s.link}>
            Vous avez déjà un compte ?{' '}
            <span
              className={s.underline}
              onClick={() => setShowSubscribe(false)}
            >
              Connectez-vous
            </span>
          </div>
        }
        submit={{
          isLoading,
          onSubmit: handleSubmit(onSubmit),
          label: 'Créer mon compte',
          isValid,
        }}
      />
    </form>
  )
}

export default SubscribeForm
